module.exports = __webpack_public_path__ + "img/read0.5e710d66.png";